import { createSlice } from '@reduxjs/toolkit'
import { consoleLog } from 'utils/Logger'
import { getCookie } from 'utils/cokie'

const isToken: boolean = getCookie('refresh_token') === null ? false : true
consoleLog('istoken=' + isToken)
consoleLog('istoken=' + getCookie('refresh_token'))
const initialState = {
  isLoggedIn: isToken,
  isLoading: false,
  errors: [
    {
      message: '',
      extensions: {
        code: '',
      },
    },
  ],
}
export const globalSlice = createSlice({
  name: 'globalData',
  initialState: initialState,
  reducers: {
    showLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setError: (state, action) => {
      state.errors = action.payload
    },
  },
})
export const setLoadingData = (value: boolean) => async (dispatch) => {
  dispatch(showLoading(value))
}

export const { showLoading, setError } = globalSlice.actions
export const global = (state) => state.globalData
export default globalSlice.reducer
